import { observer } from "mobx-react-lite";
import { KeyValueCustomSelect } from "@smartsuite/react-ui/lib";
import { useState } from "react";
import type { LimitAndSortDescription } from "@smartsuite/automation-engine-api";
import { CaptionBlock } from "../../../../../../../../components/CaptionBlock";
import { FieldMissingError } from "../../../../../../Sections/ErrorSection";
import { getLocalCssColorVariables } from "../../../../../../../../utils/cssVariablesUtils";
import { StyledReactSelectFieldContainer } from "../../../../SelectEditor/InputSelectStyles";
import { useTheme } from "../../../../../../../../stores";
import { translateIfPresent } from "../../../../../../../../locales/i18n";

export const SortByInput = observer<{
  value: string;
  limitAndSortData: LimitAndSortDescription;
  fieldMissingErrorMessage: string;
  onChange: (value: string) => void;
}>(({ value, limitAndSortData, fieldMissingErrorMessage, onChange }) => {
  const [open, setOpen] = useState<boolean>(false);
  const theme = useTheme();
  const onOpendChange = (e: boolean): void => {
    setOpen(e);
  };
  const options: Array<Record<string, unknown>> = limitAndSortData.fields.map(
    (field) => ({
      value: field.id,
      label: field.title,
    }),
  );
  return (
    <StyledReactSelectFieldContainer>
      <CaptionBlock
        description={{
          label: translateIfPresent(
            "caption.Sort the Records Found by",
            "Sort the Records Found by",
          ),
          subLabel: "",
          icon: "",
          dynamic: false,
        }}
      />
      <KeyValueCustomSelect
        my="left top+2"
        state={
          fieldMissingErrorMessage !== ""
            ? "error"
            : open
              ? "active"
              : "default"
        }
        value={value}
        placeholder=""
        showClear={false}
        placeholderArrowStyle="filled-dark"
        options={options}
        className={open ? "container-is-open" : ""}
        portalStyles={getLocalCssColorVariables(theme)}
        onOpenedChange={onOpendChange}
        onChange={(value) => {
          onChange(value as string);
        }}
      />
      <FieldMissingError message={fieldMissingErrorMessage} />
    </StyledReactSelectFieldContainer>
  );
});
